import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = ["id"];
const _hoisted_3 = {
    key: 0,
    class: "d-inline-flex justify-content-center align-items-center flex-column h-100"
};
const _hoisted_4 = { class: "fw-bold text-primary small" };
import { loadTenantConfigs, standardFunctions } from '@/Configurator/Composables/standardFunctions';
import axios from 'axios';
import { Canvas, FabricImage, filters, initFilterBackend, util } from 'fabric';
import { onMounted, ref } from 'vue';
import BottlePrintAreaPreview from './BottlePrintAreaPreview.vue';
import { useI18n } from 'vue-i18n';
//Bottle
export default /*@__PURE__*/ _defineComponent({
    __name: 'PreviewContainer',
    props: {
        configurationId: String,
        tenantId: String,
        bottle: Object,
        previewHeight: Number,
        sideView: {
            type: String,
            default: 'front'
        },
        rotate: {
            type: Boolean,
            default: false
        },
        bottleOverlay: {
            type: Number,
            default: 0
        }
    },
    setup(__props) {
        const { t } = useI18n();
        let { mmToPx } = standardFunctions();
        const props = __props;
        const standardProductType = ref(null);
        const configurationKey = ref(Math.random().toString(36).substring(7));
        const scaleFactor = ref(8); //Scale Faktor?
        const exactPreviewHeight = ref(500); //Genauigkeit der Vorschau Höhe
        const bottlePrintAreas = ref([]);
        const selectedLid = ref(null);
        // const selectedLidVariant = ref<LidVariant | null>(null);
        const selectedComponents = ref([]);
        //Preview
        const imageCompilationPossible = ref(true); //Bildzusammenstellung möglich //TODO: check if possible or show componentes in other way
        const bottlepreview = ref(new Canvas()); //Flaschen Vorschau
        const loadingPreview = ref(false); //Ladevorschau
        const bottlepreviewWidth = ref(0);
        const bottlepreviewHeight = ref(0);
        onMounted(async () => {
            standardProductType.value = await loadTenantConfigs('standard_product_type');
            if (props.bottle == null) {
                return;
            }
            exactPreviewHeight.value = props.previewHeight ?? 500;
            scaleFactor.value = mmToPx(props.bottle.height) / exactPreviewHeight.value; //Lid height is not included in this step!
            loadPreview();
        });
        function loadPreview() {
            axios.post(route('configurator.lids.selection.load', props.configurationId), {})
                .then(function (response) {
                if (response.data != null && response.data != '') {
                    selectedLid.value = response.data.lid;
                    // selectedLidVariant.value = response.data.lidVariant;
                    selectedComponents.value = response.data.components;
                }
                setTimeout(() => {
                    assembleImages();
                    if (props.bottle) {
                        props.bottle.printAreas.forEach((printArea) => {
                            loadBottleConfiguration(printArea.id);
                        });
                    }
                }, 500);
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadBottleConfiguration(printAreaId) {
            axios.post(route('configurator.bottleConfiguration.load', props.configurationId), {
                bottleId: props.bottle ? props.bottle.id : null,
                printAreaId: printAreaId
            })
                .then(function (response) {
                bottlePrintAreas.value.push({
                    id: printAreaId,
                    width: response.data.printArea.printWidth,
                    height: response.data.printArea.printHeight,
                    bottomDistance: response.data.printArea.bottomDistanceToPrintArea,
                    canvas: new Canvas('', {
                        width: mmToPx(response.data.printArea.printWidth) / scaleFactor.value,
                        height: mmToPx(response.data.printArea.printHeight) / scaleFactor.value
                    })
                });
                loadPrintConfigurationData(printAreaId, response.data.id); //Load print configuration data if already saved
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadPrintConfigurationData(printAreaId, bottleConfigurationComponentId = null) {
            if (bottleConfigurationComponentId) {
                const currentPrintArea = bottlePrintAreas.value.find((printArea) => printArea.id == printAreaId);
                if (currentPrintArea == null) {
                    return;
                }
                axios.post(route('configurator.printConfiguration.load', bottleConfigurationComponentId), {
                    configurationType: 'bottle'
                })
                    .then(function (response) {
                    if (response.data.configuration) {
                        new Canvas()
                            .loadFromJSON(response.data.configuration)
                            .then((canvas) => {
                            currentPrintArea.canvas.clear();
                            // Neue Canvas-Größe (falls sie sich geändert hat)
                            const newWidth = currentPrintArea.canvas.width;
                            const newHeight = currentPrintArea.canvas.height;
                            // Originalgröße aus gespeicherten Daten
                            const originalWidth = canvas.width;
                            const originalHeight = canvas.height;
                            // Skalierungsfaktoren berechnen
                            const scaleX = newWidth / originalWidth;
                            const scaleY = newHeight / originalHeight;
                            canvas.getObjects().forEach((obj) => {
                                // Skalierung anpassen
                                obj.scaleX = (obj.scaleX || 1) * scaleX;
                                obj.scaleY = (obj.scaleY || 1) * scaleY;
                                obj.left = (obj.left || 0) * scaleX;
                                obj.top = (obj.top || 0) * scaleY;
                                obj.setCoords();
                                currentPrintArea.canvas.add(obj);
                            });
                            currentPrintArea.canvas.renderAll();
                            currentPrintArea.previewImageSrc = util.toDataURL(currentPrintArea.canvas.getElement(), 'png', 1);
                        });
                    }
                })
                    .catch(function (error) {
                    console.log(error);
                });
            }
        }
        //Preview
        function assembleImages(printArea = null, bottlePrintAreaCanvas = null) {
            //prevent multiple calls when rotating
            if (props.rotate && bottlePrintAreaCanvas != null) {
                return;
            }
            let selectedLidHeight = 0;
            if (props.bottle == null) {
                return;
            }
            if (selectedLid.value != null) {
                selectedLidHeight = selectedLid.value.height;
            }
            loadingPreview.value = true;
            let currentTopDistance = 0;
            let maxTopDistance = 0;
            selectedComponents.value = selectedComponents.value.filter(component => component.showPreview);
            const allComponentsHaveTopDistance = selectedComponents.value.every(component => component.topDistance != null && component.topDistance != 0);
            if (!allComponentsHaveTopDistance) {
                let previewComponentsLength = selectedComponents.value.filter(component => component.showPreview).length;
                maxTopDistance = (previewComponentsLength * selectedLidHeight) - selectedLidHeight;
                if (maxTopDistance == 0) {
                    maxTopDistance = selectedLidHeight * 2;
                }
            }
            //TODO: Calculate scaleFactor: Remove if causes errors
            scaleFactor.value = (mmToPx(props.bottle.height) + mmToPx(selectedLidHeight + maxTopDistance)) / exactPreviewHeight.value;
            //Bottle and cover images
            bottlepreviewWidth.value = mmToPx(props.bottle.diameter) / scaleFactor.value;
            bottlepreviewHeight.value = (mmToPx(props.bottle.height) + mmToPx(selectedLidHeight + maxTopDistance)) / scaleFactor.value;
            if (bottlepreview.value) {
                bottlepreview.value.clear();
                bottlepreview.value.dispose();
            }
            bottlepreview.value = new Canvas('bottlePreview' + configurationKey.value, {
                width: bottlepreviewWidth.value,
                height: bottlepreviewHeight.value
            });
            let imagePromises = [];
            if (imageCompilationPossible.value) {
                if (selectedComponents.value.length > 0) {
                    selectedComponents.value.forEach(component => {
                        if (component.showPreview) {
                            imagePromises.push(loadComponentImage(component, currentTopDistance));
                            currentTopDistance += selectedLidHeight;
                        }
                    });
                }
            }
            imagePromises.push(loadConfigImage(selectedLidHeight, maxTopDistance));
            if (bottlePrintAreaCanvas && printArea) {
                imagePromises.push(loadConfigurationImage(printArea, bottlePrintAreaCanvas));
            }
            Promise.all(imagePromises).then(() => {
                bottlepreview.value.renderAll();
                if (props.rotate == false) {
                    const png = util.toDataURL(bottlepreview.value.toCanvasElement(), 'png', 1);
                    // const png = await exportPreviewCanvasAsPNG(bottlepreview.value as Canvas, 5);
                    axios.post(route('configurator.configurations.previewImages.store', props.configurationId), {
                        printAreaId: printArea ? printArea.id : props.bottle.printAreas[0].id,
                        image: png,
                        view: props.sideView
                    })
                        .catch(function (error) {
                        console.log(error);
                    });
                }
                loadingPreview.value = false;
            });
        }
        async function loadComponentImage(component, topDistance) {
            return FabricImage.fromURL(component.image).then(function (oImg) {
                if (component.colorId != null) {
                    var filter = new filters.BlendColor({
                        color: component.hexColor,
                        mode: 'multiply',
                        alpha: 1.0
                    });
                    oImg.filters.push(filter);
                    oImg.applyFilters();
                }
                oImg.scaleToWidth(bottlepreviewWidth.value);
                let componentBottleAspectRation = component.width != null && props.bottle ? (component.width / props.bottle.diameter) : 0.7;
                oImg.scaleX = oImg.scaleX * componentBottleAspectRation;
                oImg.scaleY = oImg.scaleX;
                oImg.set({
                    top: mmToPx(component.topDistance != null ? component.topDistance : topDistance) / scaleFactor.value,
                    left: ((bottlepreview.value.width - oImg.width * oImg.scaleX) / 2) - (15 / scaleFactor.value)
                });
                oImg.selectable = false;
                bottlepreview.value.add(oImg);
                //bottlepreview.sendToBack(oImg);
                return oImg;
            });
        }
        async function loadConfigImage(lidHeight, maxTopDistance) {
            return FabricImage.fromURL(props.bottle.configImageSrc).then(function (oImg) {
                if (lidHeight != 0) {
                    oImg.scaleToWidth(bottlepreviewWidth.value - 1); //TODO: check if -1 needed; -1 is needed for the bottle preview, otherwise the bottle is not displayed correctly and cropped at the bottom
                }
                else {
                    oImg.scaleToHeight(bottlepreviewHeight.value); //TODO: better scalteToWidth or scaleToHeight?
                }
                oImg.selectable = false;
                oImg.set({
                    left: 0,
                    top: lidHeight != 0 ? mmToPx(lidHeight + maxTopDistance) / scaleFactor.value : 0
                });
                //darken bottle preview
                initFilterBackend();
                var filter = new filters.BlendColor({
                    color: '#eee',
                    mode: 'difference',
                    alpha: props.bottleOverlay
                });
                oImg.filters = [];
                oImg.applyFilters();
                oImg.filters.push(filter);
                if (standardProductType.value != 'glass') {
                    oImg.applyFilters();
                }
                bottlepreview.value.add(oImg);
                bottlepreview.value.sendObjectToBack(oImg);
                bottlepreview.value.renderAll(); //TODO: check: in old version, only set for drehverschluss
                return oImg;
            });
        }
        async function loadConfigurationImage(printArea, bottlePrintAreaCanvas) {
            return FabricImage.fromURL(bottlePrintAreaCanvas.toDataURL('image/png')).then(function (oImg) {
                oImg.set({
                    left: 0,
                    top: bottlepreviewHeight.value - bottlePrintAreaCanvas.height - (mmToPx(printArea.bottomDistance) / scaleFactor.value),
                    selectable: false,
                    evented: false
                });
                bottlepreview.value.add(oImg);
                bottlepreview.value.bringObjectToFront(oImg);
                bottlepreview.value.renderAll();
                return oImg;
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _withDirectives(_createElementVNode("div", {
                    id: 'component-preview-' + props.configurationId + '-' + props.sideView,
                    class: "position-relative",
                    style: _normalizeStyle({ width: bottlepreviewWidth.value + 'px', height: bottlepreviewHeight.value + 'px' })
                }, [
                    _createElementVNode("canvas", {
                        id: 'bottlePreview' + configurationKey.value
                    }, null, 8, _hoisted_2),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bottlePrintAreas.value, (printArea) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                            (printArea.previewImageSrc)
                                ? (_openBlock(), _createBlock(BottlePrintAreaPreview, {
                                    key: 0,
                                    class: "position-absolute",
                                    diameter: bottlepreviewWidth.value,
                                    height: (_unref(mmToPx)(printArea.height) / scaleFactor.value),
                                    textureUrl: printArea.previewImageSrc,
                                    sideView: props.sideView,
                                    rotate: props.rotate,
                                    style: _normalizeStyle({ bottom: (_unref(mmToPx)(printArea.bottomDistance) / scaleFactor.value) + 'px', left: 0 }),
                                    onExportImage: ($event) => (assembleImages(printArea, $event))
                                }, null, 8, ["diameter", "height", "textureUrl", "sideView", "rotate", "style", "onExportImage"]))
                                : _createCommentVNode("", true)
                        ]));
                    }), 256))
                ], 12, _hoisted_1), [
                    [_vShow, !loadingPreview.value]
                ]),
                (loadingPreview.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _cache[0] || (_cache[0] = _createElementVNode("div", {
                            class: "spinner-grow text-primary mb-3",
                            role: "status",
                            style: { "width": "2rem", "height": "2rem" }
                        }, [
                            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                        ], -1)),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('Vorschau wird geladen')), 1)
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
